import { useQuery } from '@tanstack/react-query'
import { useTypedApiClient } from 'hooks/useTypedApiClient'

export const useGetRewardProgramById = (id: number) => {
  const get = useTypedApiClient({
    path: '/admin/rewards-programs/{id}',
    method: 'get',
  })

  return useQuery({
    queryKey: ['/admin/rewards-programs', id],
    queryFn: async () => {
      const { data } = await get({ id })
      return data
    },
  })
}
